<template>
    <properties-block v-bind="$props" v-on="$listeners">
        <template #layout>
            <b-form-group label-cols="4">
                <template #label>
                    <span v-tr>Max Col.|Max Col.</span>
                    <e-hint class="ml-2" text="Max columns visible|Nombre maximal de colonnes visibles"/>
                    <btn-responsive-prop v-model="block" field="columns"/>
                </template>
                <b-select v-model.number="block.mediaProxy.maxColumns">
                    <option :value="0" v-tr>Auto|Automatique</option>
                    <option v-for="n in 10" :key="`columns-${n}`" :value="`${n}`">{{n}}</option>
                </b-select>
            </b-form-group>
        </template>
        <template #spacing>
            <b-form-group>
                <b-btn @click="block.propagatePadding()" variant="white">
                    <span v-tr>Apply padding in cascade|Appliquer le padding aux enfants</span>
                </b-btn>
            </b-form-group>
        </template>
    </properties-block>
</template>

<script>
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";
import SimpleListViewItem from "@components/editor/properties/simple-list-view-item.vue";
import EHint from "@vue-components/components/e-hint.vue";

export default {
    name: `properties-block-table`,
    components: {EHint, SimpleListViewItem, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
